import { render, staticRenderFns } from "./DocBox.vue?vue&type=template&id=41a19bfb&scoped=true&"
import script from "./DocBox.vue?vue&type=script&lang=js&"
export * from "./DocBox.vue?vue&type=script&lang=js&"
import style0 from "./DocBox.vue?vue&type=style&index=0&id=41a19bfb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41a19bfb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('41a19bfb')) {
      api.createRecord('41a19bfb', component.options)
    } else {
      api.reload('41a19bfb', component.options)
    }
    module.hot.accept("./DocBox.vue?vue&type=template&id=41a19bfb&scoped=true&", function () {
      api.rerender('41a19bfb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-230n7phGQOPEg/JS/comp/DocBox.vue"
export default component.exports